export const UserDetailsPortalProvideKey = Object.freeze({
  onInstitutionGroupClick: Symbol(),
  lockReasonValue: Symbol(),
  onUpdateLockReason: Symbol(),
  setShowLockReasonForm: Symbol(),
  refreshDataTableCallbackService: Symbol(),
  showLockReasonMaxCharacterWarning: Symbol(),
  setInstitutionProfile: Symbol(),
});
